import React from "react";

import { Formik, Form, FieldArray } from "formik";
import { Plus } from "icons";
import PropTypes from "prop-types";

import { Button, Typography, DropdownOverlay } from "clearsense-ui/components";

import ConditionBlock from "./ConditionBlock";

import { pivotedDataFilterSchema } from "../../../validations";
import { formatColumnForFilter, isColumnDynamicHeader } from "../utils";

const Filter = ({
  title,
  columnOptions,
  getPivotedData,
  state,
  sort,
  prevFilters,
  setFilters,
  setPrevFilters,
}) => {
  const addFilterCondition = arrayHelpers => {
    arrayHelpers.push({ column: "", value: "" });
  };

  const deleteFilterCondition = (arrayHelpers, idx) => {
    arrayHelpers.remove(idx);
  };

  return (
    <DropdownOverlay
      position="left"
      buttonLabel="Add Filter"
      buttonStyle="secondary"
      buttonProps={{
        icon: Plus,
        className: "text-semibold",
      }}
      className="flex-shrink-0"
    >
      {({ onClose }) => (
        <Formik
          enableReinitialize
          initialValues={prevFilters}
          validationSchema={pivotedDataFilterSchema}
          onSubmit={values => {
            const multipleFilters = values?.conditions?.map(condition => {
              const individualFilterValues = condition?.value?.map(
                ({ value }) => value
              );
              const searchColumn = isColumnDynamicHeader(
                condition?.column?.label
              )
                ? "context_value"
                : formatColumnForFilter(condition?.column?.value);

              return ` ${searchColumn} IN ('${individualFilterValues.join(
                "','"
              )}') `;
            });

            getPivotedData({
              cde: state?.selectedCde,
              page: 1,
              sort,
              filter: multipleFilters.join("AND"),
            });
            setFilters(multipleFilters.join("AND"));
            setPrevFilters(values);
          }}
        >
          {formik => (
            <Form>
              <FieldArray
                name="conditions"
                render={arrayHelpers => (
                  <div className="cs-ui-container__filter">
                    <Typography className="font-semibold mb-2">
                      {title}
                    </Typography>
                    <div className="max-h-64 overflow-y-auto">
                      {formik.values.conditions?.map((_, idx) => (
                        <div className="my-4" key={idx}>
                          <ConditionBlock
                            idx={idx}
                            state={state}
                            arrayHelpers={arrayHelpers}
                            columnOptions={columnOptions}
                            deleteFilterCondition={deleteFilterCondition}
                          />
                        </div>
                      ))}
                    </div>
                    <Button
                      label="Add condition"
                      icon={Plus}
                      iconPosition="left"
                      style="secondary"
                      className="mb-4 mt-2"
                      onClick={() => addFilterCondition(arrayHelpers)}
                    />
                    <div>
                      <Button
                        type="submit"
                        label="Done"
                        onClick={() => {
                          formik.submitForm();
                          formik.isValid && onClose();
                        }}
                      />
                    </div>
                  </div>
                )}
              />
            </Form>
          )}
        </Formik>
      )}
    </DropdownOverlay>
  );
};

Filter.propTypes = {
  title: PropTypes.string,
  columnOptions: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ),
};

export default Filter;
